module.exports = __webpack_public_path__ + "img/xzgcjx.44a75444.png";